import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import baseUrl from "../../baseUrl";
import Spinner from "../../Components/Spinner/Spinner";

const EditLabtest = ({ labtest }) => {
  const token = JSON.parse(localStorage.getItem("admin-token"));
  const [showModal, setShowModal] = useState(false);

  const [result, setResult] = useState("");
  const [id, setId] = useState("");
  const [userId, setUserId] = useState("");
  const [feedback, setFeedback] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setResult(labtest.result);
    setFeedback(labtest.feedback);
    setUserId(labtest.userId._id);
    setId(labtest._id);
  }, [labtest]);

  const handleUpdate = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        `${baseUrl}/admin/update-labtest`,
        { userId, id, status: "Done", feedback, result },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        console.log(res.data);
        if (res.data.success === true) {
          toast.success(res.data.message);
          navigate("/admin/all-labtests");
          window.location.reload();
        } else {
          toast.error(res.data.message);
          navigate("/admin/all-labtests");
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      {loading && <Spinner />}
      <button
        className="bg-green-500 text-gray-200 hover:bg-green-600 hover:text-white
                          px-3 py-2 rounded-md text-sm font-medium ml-5 hover:cursor-pointer"
        type="button"
        onClick={() => setShowModal(true)}
      >
        <i className="fa-solid fa-pen-to-square"></i>
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex flex-col items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="text-3xl font-semibold text-black">
                    Update Project
                  </h3>

                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>

                {/*body*/}

                <form onSubmit={handleUpdate}>
                  <div className="mb-4 md:mr-2 md:mb-0 ml-2">
                    <label className="block mb-2 text-sm font-bold text-gray-700">
                      Test Feedback
                    </label>
                    <textarea
                      className="w-full px-3 py-2 text-sm leading-tight focus:outline-green-500 border-green-300 text-gray-700 border  rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                      name="feedback"
                      value={feedback}
                      onChange={(e) => setFeedback(e.target.value)}
                      rows="3"
                      required
                    ></textarea>
                  </div>
                  <div className="mb-4 md:mr-2 md:mb-0 ml-2">
                    <div className="max-w-lg mx-auto">
                      <div className="flex items-center mb-4">
                        <input
                          id="Good"
                          type="radio"
                          name="result"
                          value="Good"
                          onChange={(e) => setResult(e.target.value)}
                          className="h-4 w-4 border-gray-300 focus:ring-2 focus:ring-blue-300"
                          aria-labelledby="Good"
                          aria-describedby="Good"
                          checked={result === "Good" ? "checked" : ""}
                        />
                        <label
                          htmlFor="Good"
                          className="text-sm font-medium text-gray-900 ml-2 block"
                        >
                          Good
                        </label>
                      </div>

                      <div className="flex items-center mb-4">
                        <input
                          id="Normal"
                          type="radio"
                          name="result"
                          value="Normal"
                          onChange={(e) => setResult(e.target.value)}
                          className="h-4 w-4 border-gray-300 focus:ring-2 focus:ring-blue-300"
                          aria-labelledby="Normal"
                          aria-describedby="Normal"
                          checked={result === "Normal" ? "checked" : ""}
                        />
                        <label
                          htmlFor="country-option-2"
                          className="text-sm font-medium text-gray-900 ml-2 block"
                        >
                          Normal
                        </label>
                      </div>

                      <div className="flex items-center mb-4">
                        <input
                          id="Critical"
                          type="radio"
                          name="result"
                          value="Critical"
                          onChange={(e) => setResult(e.target.value)}
                          className="h-4 w-4 border-gray-300 focus:ring-2 focus:ring-blue-300"
                          aria-labelledby="Critical"
                          aria-describedby="Critical"
                          checked={result === "Critical" ? "checked" : ""}
                        />
                        <label
                          htmlFor="country-option-3"
                          className="text-sm font-medium text-gray-900 ml-2 block"
                        >
                          Critical
                        </label>
                      </div>
                    </div>
                  </div>
                  {/*body*/}
                  {/*footer*/}
                  <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                    <button
                      className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="button"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                    <button
                      className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                      type="submit"
                    >
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default EditLabtest;
